import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-share-quote.css.lit';

/**
 * The SeShareQuote component
 * @element se-share-quote
 */
@customElement('se-share-quote')
export class SeShareQuote extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String })
  quote: string;

  render(): TemplateResult {
    return html`<div class="se-share-quote">
      <outline-icon
        name="quote"
        library="system"
        color="brand-primary-2"
        size="1em"
      >
      </outline-icon>
      <blockquote class="quote">${this.quote}</blockquote>

      <div class="share-btn">
        <se-button
          button-label="Share on twitter"
          button-url="https://twitter.com/intent/tweet?url=${window.location
            .href}&text=${this.quote} "
          size="medium"
          variant="primary-2"
          >Share with
          <outline-icon name="twitter" library="system" size="1em">
          </outline-icon
        ></se-button>
      </div>
    </div>`;
  }
}
